var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "code_line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Development",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "code_line"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4858,3.14342 C15.0175,3.29266 15.3276,3.84471 15.1784,4.37644 L10.7473,20.1638 C10.598,20.6955 10.046,21.0056 9.51425,20.8563 C8.98251,20.7071 8.67244,20.155 8.82169,19.6233 L13.2528,3.83598 C13.402,3.30424 13.9541,2.99417 14.4858,3.14342 Z M7.20707,7.05001 C7.5976,7.44053 7.5976,8.0737 7.20707,8.46422 L3.67154,11.9998 L7.20707,15.5353 C7.5976,15.9258 7.5976,16.559 7.20707,16.9495 C6.81655,17.34 6.18338,17.34 5.79286,16.9495 L1.55022,12.7069 C1.36268,12.5193 1.25732,12.265 1.25732,11.9998 C1.25732,11.7345 1.36268,11.4802 1.55022,11.2927 L5.79286,7.05001 C6.18338,6.65949 6.81655,6.65949 7.20707,7.05001 Z M16.7929,8.46422 C16.4023,8.0737 16.4023,7.44053 16.7929,7.05001 C17.1834,6.65949 17.8165,6.65949 18.2071,7.05001 L22.4497,11.2927 C22.6372,11.4802 22.7426,11.7345 22.7426,11.9998 C22.7426,12.265 22.6372,12.5193 22.4497,12.7069 L18.2071,16.9495 C17.8165,17.34 17.1834,17.34 16.7929,16.9495 C16.4023,16.559 16.4023,15.9258 16.7929,15.5353 L20.3284,11.9998 L16.7929,8.46422 Z",
    id: "\\u5F62\\u72B6",
    fill: "#D341D4FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.4f8bc3874df0c26f722c4d7a580ae2b8.svg";
export { ForwardRef as ReactComponent };